import reducer from "./reducer";
export { default as Studies } from "./components/index";
export { default as studiesReducerName } from "./constants";
export default reducer;
